// extracted by mini-css-extract-plugin
export default {"ruleSetting":"ruleSetting_c854b","content":"content_e6b77"};